import { render } from "./Modal-Drawing.vue?vue&type=template&id=2cfe77b6&scoped=true"
import script from "./Modal-Drawing.vue?vue&type=script&lang=js"
export * from "./Modal-Drawing.vue?vue&type=script&lang=js"

import "./Modal-Drawing.vue?vue&type=style&index=0&id=2cfe77b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cfe77b6"]])

export default __exports__